
export const LOAD_REPORT_INFO_REQUEST = "[REPORT INFO] LOAD REPORT INFO REQUEST";
export const LOAD_REPORT_INFO_SUCCESS = "[REPORT INFO] LOAD REPORT INFO SUCCESS";
export const LOAD_REPORT_INFO_ERROR = "[REPORT INFO] LOAD REPORT INFO ERROR";
